import { MatDialog } from '@angular/material/dialog';
import { BaseService } from 'src/app/core/services/base.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { OiGroupDialogData, OiGroupProcessDialogComponent } from 'src/app/shared/oi-group-process-dialog/oi-group-process-dialog.component';
import { ConfirmDialogTemplateComponent } from '@optsolservices/ngx-confirm-dialog';
import { PosTfgAccountPayWithMoneyEquipmentComponent } from '../../pos-tfg-account-pay-with-money-equipment/pos-tfg-account-pay-with-money-equipment.component';

@Component({
  selector: 'app-pos-payment-tfg-vision',
  templateUrl: './pos-payment-tfg-vision.component.html',
  styleUrls: ['./pos-payment-tfg-vision.component.scss']
})
export class PosPaymentTfgVisionComponent implements OnInit, OnDestroy {
  @Input() amountOutstanding: number;
  @Input() storeId: number;
  @Input() containerId: number;
  @Input() containerDesc: string
  @Input() equipmentTypeCode: string;
  @Input() paymentType: string;
  @Input() salesOrderNumber: string;
  @Input() invoiceNumber: string;

  @Output() formChanged: EventEmitter<any> = new EventEmitter<any>(null);

  idDocumentVerified = false;
  formSubscription: Subscription;
  form: FormGroup;

  tfgAccountDetails: any = null;

  constructor(
    private fb: FormBuilder,
    private baseService: BaseService,
    private dialog: MatDialog
  ) {
    this.form = fb.group({
      amountTendered: [null, Validators.compose([Validators.required, Validators.min(1)])],
      amountOutstanding: [null],
      amountDifference: [null],
      tfgCardNumber: [null, Validators.compose([Validators.required, Validators.minLength(19), Validators.maxLength(19), Validators.pattern('[0-9]+')])],
      trackTwo: [null],
      accountHolder: [null],
      otbBalance: [null],
      creditPlan: [null, Validators.compose([Validators.required])],
      validationRequestId: [null, Validators.compose([Validators.required])]
    });
  }

  ngOnInit() {
    if (this.paymentType && (this.paymentType === 'REFUND' || this.paymentType === 'DEPOSIT-REFUND')) {
      this.form.controls['amountTendered'].setValidators(Validators.compose([Validators.required, Validators.max(-1)]));
    } else {
      this.form.controls['amountTendered'].setValidators(Validators.compose([Validators.required, Validators.min(1)]));
    }


    this.form.controls['amountOutstanding'].disable();
    this.form.controls['amountDifference'].disable();
    this.form.controls['otbBalance'].disable();
    this.form.controls['accountHolder'].disable();

    this.amountTenderedChanged();
    // this.amountTenderedFocusOut();

    this.formChanged.emit({
      containerId: this.containerId,
      equipmentTypeCode: this.equipmentTypeCode,
      formValue: this.form.getRawValue(),
      formValid: this.form.valid,
    });

    this.formSubscription = this.form.valueChanges.subscribe(s => {
      this.formChanged.emit({
        containerId: this.containerId,
        equipmentTypeCode: this.equipmentTypeCode,
        formValue: this.form.getRawValue(),
        formValid: this.form.valid,
      });
    });
  }

  ngOnDestroy(): void {
    if (this.formSubscription) {
      this.formSubscription.unsubscribe();
    }
  }

  amountTenderedChanged() {
    const amountTendered = +this.form.value.amountTendered || 0;
    const amountToPay = +this.amountOutstanding || 0;
    const minusOutstanding = amountTendered - amountToPay;

    this.form.controls['amountOutstanding'].setValue(+amountToPay.toFixed(2));
    this.form.controls['amountDifference'].setValue(+minusOutstanding.toFixed(2));

  }

  amountTenderedFocusOut() {
    if(!this.form.value.amountTendered) return;

    const amountTendered = +this.form.value.amountTendered || 0;
    this.form.controls['amountTendered'].setValue(+amountTendered.toFixed(2));
  }

  validate() {
    this.tfgAccountDetails = null;
    this.form.controls['accountHolder'].reset();
    this.form.controls['otbBalance'].reset();
    this.form.controls['creditPlan'].reset();
    this.form.controls['validationRequestId'].reset();
    this.form.controls['creditPlan'].updateValueAndValidity();
    this.form.updateValueAndValidity();

    const dialogData: OiGroupDialogData = {
      title: 'Validating TFG Credit Card',
      function: 'portal_oi_group_payment_validate_tfg_card',
      postBody: Object.assign(this.form.getRawValue(), { storeId: this.storeId, portalProcess: this.paymentType && (this.paymentType === 'REFUND' || this.paymentType === 'DEPOSIT-REFUND') ? 'REFUND' : 'PAYMENT' })
    };

    const ref = this.dialog.open(OiGroupProcessDialogComponent, {
      data: dialogData,
      width: '450px'
    });

    ref.afterClosed().subscribe(oiResult => {
      if (oiResult.responseCode === 0 && oiResult.data && oiResult.data.groupProcessedSuccessfully === true) {
        this.baseService.executeCommand<any>('portal_pos_payment_tfg_validation_details', oiResult.data).subscribe(detailResponse => {
          if (detailResponse.responseCode === 0) {
            this.tfgAccountDetails = detailResponse.data;

            this.form.controls['accountHolder'].setValue(`${this.tfgAccountDetails.title} ${this.tfgAccountDetails.initials} ${this.tfgAccountDetails.surname}`);
            this.form.controls['otbBalance'].setValue(this.tfgAccountDetails.openToBuyAmount);
            this.form.controls['validationRequestId'].setValue(this.tfgAccountDetails.requestId);
            this.form.controls['tfgCardNumber'].disable();

            if (this.paymentType && (this.paymentType === 'REFUND' || this.paymentType === 'DEPOSIT-REFUND')) {
              if (this.paymentType === 'REFUND') {
                this.form.controls['amountTendered'].setValidators([Validators.required, Validators.max(-1)]);
              } else {
                this.form.controls['amountTendered'].setValidators([Validators.required, Validators.min(1), Validators.max(this.amountOutstanding)]);
              }
              this.form.controls['creditPlan'].clearValidators();
            } else {
              this.form.controls['amountTendered'].setValidators([Validators.required, Validators.min(1), Validators.max(this.tfgAccountDetails.openToBuyAmount)]);
            }

            this.form.controls['creditPlan'].updateValueAndValidity();
            this.form.updateValueAndValidity();

            if (this.idDocumentVerified === false && this.tfgAccountDetails.accountStatusCode === 21) {
              const dialogRef = this.dialog.open(ConfirmDialogTemplateComponent, {
                width: '450px',
                data: {
                  title: `${this.tfgAccountDetails.accountStatusCode} - ${this.tfgAccountDetails.accountStatus}`,
                  text: 'IMPORTANT: Please verify the ID document of the customer.',
                  confirmButtonText: 'I have verified the ID Document',
                  cancelButtonText: '',
                  showConfirmButton: true,
                  showCancelButton: false
                }
              });

              dialogRef.afterClosed().subscribe(result => {
                this.idDocumentVerified = true;
              });
            }
          }
        });
      }
    });
  }

  resetValidation() {
    this.tfgAccountDetails = null;
    this.form.controls['accountHolder'].reset();
    this.form.controls['otbBalance'].reset();
    this.form.controls['creditPlan'].reset();
    this.form.controls['validationRequestId'].reset();
    this.form.controls['tfgCardNumber'].reset();
    this.form.controls['tfgCardNumber'].enable();
    this.form.controls['trackTwo'].reset();
    this.form.controls['creditPlan'].updateValueAndValidity();
    this.form.controls['amountTendered'].setValidators([Validators.required, Validators.min(1)]);
    this.form.updateValueAndValidity();
    this.idDocumentVerified = false;
  }

  checkForTfgCardScan(event, value: string) {
    if (value) {
      const regex = new RegExp(`^;[0-9]{19}=[0-9]{17}\\?$`);
      if (regex.test(value)) {
        console.log('TFG card!!');
        const cardPieces = value.split('=');
        const cardNumber = cardPieces[0].replace(';','');
        this.form.controls['tfgCardNumber'].setValue(cardNumber);
        this.form.controls['trackTwo'].setValue(value);
        this.validate();
      } else {
        this.form.controls['trackTwo'].setValue(null);
      }
    }
  }

  payAccount(subType: string) {
    const tfgOtbAccountDetails = JSON.parse(JSON.stringify(this.tfgAccountDetails));
    tfgOtbAccountDetails.accountBalanceAmount = Math.ceil(+this.amountOutstanding - this.tfgAccountDetails.openToBuyAmount);
    tfgOtbAccountDetails.salesOrderNumber = this.salesOrderNumber;
    tfgOtbAccountDetails.invoiceNumber = this.invoiceNumber;

    const ref = this.dialog.open(PosTfgAccountPayWithMoneyEquipmentComponent, {
      data: Object.assign(tfgOtbAccountDetails, { subType: subType }),
      width: '800px'
    });

    ref.afterClosed().subscribe(response => {
      this.validate();
    });
  }

}
